module.exports = __webpack_public_path__ + "img/pragmatic-n.95bff55b.png";